import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/food.vue
var s = {
	name: "DtIconFood",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--food"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Food",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M7.87.517a.5.5 0 0 1 .61.34l3 10a.5.5 0 0 1-.623.622l-10-3a.5.5 0 0 1-.34-.608 10.429 10.429 0 0 1 2.69-4.664A10.438 10.438 0 0 1 7.871.516ZM3.915 3.914a9.438 9.438 0 0 0-2.293 3.75l1.01.304c.407-1.345 1-2.484 1.874-3.39.88-.911 2.015-1.558 3.46-1.957l-.3-1a9.444 9.444 0 0 0-3.751 2.293Zm4.338-.335c-1.313.359-2.289.928-3.027 1.693-.735.762-1.262 1.747-1.635 2.983l6.665 2-2.003-6.676ZM7 5.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5a.5.5 0 0 1-.5-.5Zm-2 2a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H5.5a.5.5 0 0 1-.5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H8a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=food.js.map